import React, { useEffect, useState } from "react";
import { money } from "@/lib/financeApi";
import { reApi, errMsg } from "@/lib/residentApi";

const BUCKETS = [["checking", "Cash in Hand"], ["savings", "Savings"], ["loan", "Line of Credit"], ["escrow", "Rent"], ["program_fee", "PACT Fee"]];

/** Read-only money view for a partner with Resident financial records access. */
export default function PartnerFinance({ resident }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { reApi.get(`/residents/${resident.id}/partner-finance`).then(setD).catch((e) => setErr(errMsg(e))); }, [resident.id]);
  if (err) return <p data-testid="partner-finance-error" className="text-sm text-red-300">{err}</p>;
  if (!d) return <p className="text-sm text-nex-muted">Loading…</p>;
  return (
    <div data-testid="partner-finance" className="space-y-6">
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        {BUCKETS.map(([k, l]) => (
          <div key={k} data-testid={`partner-finance-balance-${k}`} className="border border-white/10 p-2">
            <div className="font-mono text-[9px] uppercase text-nex-muted">{l}</div>
            <div className="font-mono text-sm text-nex-gold">{k === "loan" ? `${money(-(d.balances.loan || 0))} owed` : money(d.balances[k] || 0)}</div>
          </div>
        ))}
      </div>
      <div>
        <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted mb-2">Recent ledger · last {d.recent.length}</div>
        {d.recent.length ? d.recent.map((t) => (
          <div key={t.id} data-testid={`partner-finance-row-${t.id}`} className="flex items-start gap-2 border-b border-white/5 py-1">
            <div className="flex-1 text-sm text-nex-silver">{String(t.bucket).replace(/_/g, " ")} · {String(t.type).replace(/_/g, " ")}
              <div className="text-xs text-nex-muted">{new Date(t.created_at).toLocaleDateString()}{t.description ? ` · ${t.description}` : ""}</div></div>
            <div className="font-mono text-sm text-nex-gold">{t.direction === "debit" ? "−" : "+"}{money(t.amount)}</div>
          </div>
        )) : <p className="text-sm text-nex-muted">No ledger entries.</p>}
      </div>
    </div>
  );
}
